import React from 'react';
import NavBar from '../nav/NavBar.tsx';
import './Terms.css';

function HomePage() {
  return (
    <>
      <NavBar></NavBar>
      <div className={'overlay'}>
      <div className={'viewport'}>
        Terms of Use<br></br>
Effective Date: August 4, 2025<br></br>
These Terms of Use ("Terms") govern your use of all mobile applications ("Apps") developed and published by [The DezLab LLC] ("Developer," "we," "our," or "us"). By downloading, installing, or using the Apps, you agree to these Terms. If you do not agree, do not use the Apps.<br></br>
<br></br>
1. License<br></br>
Subject to these Terms and Apple's App Store Terms and Conditions, we grant you a limited, non-exclusive, non-transferable, revocable license to download and use the Apps solely for your personal, non-commercial use.<br></br>
This license does not transfer ownership of the Apps or any intellectual property.<br></br>
<br></br>
2. Eligibility<br></br>
You must comply with all applicable laws when using the Apps.<br></br>
If you are under the age required to enter into a legally binding agreement in your jurisdiction, you should use the Apps only with the permission and supervision of a parent or legal guardian.<br></br>
<br></br>
3. Acceptable Use<br></br>
You agree not to:<br></br>
* Copy, modify, or redistribute the Apps except as permitted by law.<br></br>
* Reverse engineer, decompile, or attempt to extract the source code except where expressly permitted by applicable law.<br></br>
* Interfere with the operation or security of the Apps.<br></br>
* Use the Apps for unlawful or fraudulent purposes.<br></br>
* Circumvent advertisements or technical protections built into the Apps.<br></br>
<br></br>
4. Advertisements<br></br>
The Apps may display advertisements provided by Google Mobile Ads (AdMob).<br></br>
We are not responsible for the content, availability, or practices of third-party advertisers or websites that may be accessed through advertisements.<br></br>
Your interactions with advertisers are solely between you and the applicable third party.<br></br>
<br></br>
5. Intellectual Property<br></br>
The Apps, including all software, code, graphics, logos, icons, designs, text, audio, and other content, are owned by the Developer or its licensors and are protected by copyright, trademark, and other applicable intellectual property laws.<br></br>
Except as expressly permitted in these Terms, no rights are granted to you.<br></br>
<br></br>
6. Updates<br></br>
We may release updates, bug fixes, new features, or improvements at any time.<br></br>
Some features may require updating the App to continue functioning properly.<br></br>
<br></br>
7. Availability<br></br>
We do not guarantee that the Apps will always be available, uninterrupted, secure, or error-free.<br></br>
Features may be modified, suspended, or discontinued at any time without notice.<br></br>
<br></br>
8. Disclaimer of Warranties<br></br>
THE APPS ARE PROVIDED "AS IS" AND "AS AVAILABLE."<br></br>
TO THE MAXIMUM EXTENT PERMITTED BY LAW, THE DEVELOPER DISCLAIMS ALL WARRANTIES, WHETHER EXPRESS, IMPLIED, OR STATUTORY, INCLUDING WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, NON-INFRINGEMENT, AND THAT THE APPS WILL OPERATE WITHOUT INTERRUPTION OR ERROR.<br></br>
<br></br>
9. Limitation of Liability<br></br>
TO THE MAXIMUM EXTENT PERMITTED BY LAW, THE DEVELOPER SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, EXEMPLARY, OR PUNITIVE DAMAGES, INCLUDING LOSS OF DATA, LOSS OF PROFITS, LOSS OF BUSINESS, OR BUSINESS INTERRUPTION ARISING OUT OF OR RELATED TO YOUR USE OF THE APPS.<br></br>
TO THE MAXIMUM EXTENT PERMITTED BY LAW, THE DEVELOPER'S TOTAL LIABILITY FOR ANY CLAIM ARISING FROM THE APPS SHALL NOT EXCEED THE GREATER OF:<br></br>
* THE AMOUNT YOU PAID FOR THE APP (IF ANY), OR<br></br>
* TEN U.S. DOLLARS (US $10.00).<br></br>
SOME JURISDICTIONS DO NOT ALLOW CERTAIN LIMITATIONS OF LIABILITY, SO SOME OF THE ABOVE LIMITATIONS MAY NOT APPLY TO YOU.<br></br>
<br></br>
10. Indemnification<br></br>
To the extent permitted by law, you agree to indemnify and hold harmless the Developer, its owners, officers, employees, contractors, and affiliates from claims, damages, liabilities, costs, and expenses arising from:<br></br>
* Your misuse of the Apps;<br></br>
* Your violation of these Terms; or<br></br>
* Your violation of applicable law or the rights of another person.<br></br>
<br></br>
11. Arbitration and Dispute Resolution<br></br>
To the fullest extent permitted by applicable law, any dispute arising out of or relating to these Terms or the Apps shall first be submitted to informal negotiation by written notice.<br></br>
If the dispute is not resolved within thirty (30) days, it shall be resolved through binding arbitration administered by a recognized arbitration provider under its applicable consumer arbitration rules.<br></br>
The arbitration shall be conducted before a single neutral arbitrator.<br></br>
The arbitrator shall have exclusive authority to determine issues relating to the interpretation and enforceability of this arbitration agreement, except where prohibited by law.<br></br>
<br></br>
12. Class Action Waiver<br></br>
To the fullest extent permitted by law, all disputes shall be resolved only on an individual basis.<br></br>
Neither you nor the Developer may participate in a class action, collective action, representative action, or consolidated proceeding.<br></br>
<br></br>
13. Exceptions<br></br>
Nothing in these Terms prevents either party from:<br></br>
* Bringing an individual claim in small claims court where permitted;<br></br>
* Seeking temporary or preliminary injunctive relief to protect intellectual property rights;<br></br>
* Exercising rights that applicable law does not permit to be waived.<br></br>
<br></br>
14. Governing Law<br></br>
These Terms shall be governed by the laws of the State of [Your State], without regard to conflict of law principles, except where superseded by applicable consumer protection laws.<br></br>
<br></br>
15. Severability<br></br>
If any provision of these Terms is held invalid or unenforceable, the remaining provisions shall remain in full force and effect.<br></br>
<br></br>
16. Changes to These Terms<br></br>
We may update these Terms from time to time.<br></br>
The updated version becomes effective when published with a revised Effective Date.<br></br>
Your continued use of the Apps after the updated Terms become effective constitutes acceptance of the revised Terms.<br></br>
<br></br>
17. Contact Information<br></br>
[The DezLab LLC]<br></br>
Email: [support@thedezlab.com]<br></br>
<br></br>
18. Apple App Store Additional Terms<br></br>
These Terms are between you and the Developer only, and not Apple Inc. Apple is not responsible for the Apps or their content.<br></br>
Apple has no obligation to provide maintenance or support services for the Apps.<br></br>
To the extent permitted by law, Apple shall have no warranty obligations regarding the Apps.<br></br>
Apple and its subsidiaries are third-party beneficiaries of these Terms and may enforce these Terms against you as applicable.<br></br>

      </div>
      </div>
    </>
  );
}

export default HomePage;
